module.exports = __webpack_public_path__ + "static/img/bm-statistics.e762ef5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/bm-statistics.svg
// module id = Hnay
// module chunks = 3